export default "__VITE_ASSET__47338092__"